module.exports = {
    stopwords: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '0',
        '۱',
        '۲',
        '۳',
        '۴',
        '۵',
        '۶',
        '۷',
        '۸',
        '۹',
        '۰',
        '،',
        '!',
        '\"',
        '\'',
        '`',
        '»',
        '«',
        '{',
        '}',
        '(',
        ')',
        '%',
        'درصد',
        'فیصد',
        '-',
        ';',
        '؛',
        '؛',
        'ً',
        'ٌ',
        'ٍ',
        '',
        'َ',
        'ُ',
        'ِ',
        'ّ',
        ']',
        '[',
        '@',
        '#',
        '$',
        '%',
        '&',
        '*',
        'ات',
        'اتفاقا',
        'اجراست',
        'احتمالا',
        'احيانا',
        'اخ',
        'اختصارا',
        'اخر',
        'اخرها',
        'اخه',
        'اخيرا',
        'ادمهاست',
        'اراسته',
        'ارام',
        'ارزانتر',
        'ارزومندانه',
        'ارنه',
        'اره',
        'از',
        'ازادانه',
        'ازان',
        'ازانجا',
        'ازانجاكه',
        'ازاين',
        'ازاينرو',
        'ازبه',
        'ازجمله',
        'ازروي',
        'ازسر',
        'ازش',
        'ازقبيل',
        'ازلحاظ',
        'ازنظر',
        'ازو',
        'ازيك',
        'اساس',
        'اساسا',
        'اسان',
        'اسانتر',
        'اساني',
        'است',
        'استوارتر',
        'اسيبپذيرند',
        'اش',
        'اشان',
        'اشتباها',
        'اشفته',
        'اشكار',
        'اشكارا',
        'اشكارتر',
        'اشنايند',
        'اصطلاحا',
        'اصلا',
        'اصولا',
        'اطلاعند',
        'اغلب',
        'افزودن',
        'افسوس',
        'افقي',
        'اقل',
        'اقلا',
        'اقليت',
        'اكتسابا',
        'اكثر',
        'اكثرا',
        'اكثريت',
        'اكنون',
        'الا',
        'الاسف',
        'الان',
        'البته',
        'الزاما',
        'الظاهر',
        'المقدور',
        'الهي',
        'الي',
        'ام',
        'اما',
        'امان',
        'امرانه',
        'امروز',
        'امروزه',
        'امسال',
        'امشب',
        'اميدوارم',
        'اميدوارند',
        'اميدواريم',
        'ان',
        'انان',
        'اناني',
        'انجا',
        'اند',
        'اندك',
        'اندكي',
        'انرا',
        'انشاالله',
        'انقدر',
        'انكس',
        'انكه',
        'انم',
        'انها',
        'انهاست',
        'انوقت',
        'انچنان',
        'انچه',
        'انگار',
        'انگاه',
        'انگه',
        'انگونه',
        'اهان',
        'اهاي',
        'او',
        'اورد',
        'اوردن',
        'اوست',
        'اول',
        'اولا',
        'اولش',
        'اون',
        'اونهمه',
        'اوه',
        'اويي',
        'اي',
        'ايا',
        'ايشان',
        'ايم',
        'اين',
        'اينان',
        'اينجا',
        'اينجاست',
        'اينجوري',
        'اينرو',
        'اينست',
        'اينطور',
        'اينقدر',
        'اينك',
        'اينكه',
        'اينها',
        'اينهاست',
        'اينهمه',
        'اينو',
        'اينچنين',
        'اينگونه',
        'اگاهانه',
        'اگر',
        'اگرنه',
        'اگرچه',
        'اگه',
        'ب',
        'با',
        'بااطمينان',
        'باانكه',
        'بااين',
        'بااينكه',
        'بار',
        'باره',
        'بارها',
        'بارهاوبارها',
        'باز',
        'بازانديشانه',
        'بازهم',
        'بازيگوشانه',
        'باستثناي',
        'باش',
        'باشد',
        'باعلاقه',
        'بالا',
        'بالاتر',
        'بالاخره',
        'بالاخص',
        'بالاست',
        'بالاي',
        'بالضرور',
        'بالطبع',
        'بالعكس',
        'بالقوه',
        'بالله',
        'بالنتيجه',
        'بالنسبه',
        'باهم',
        'باوجود',
        'باوجودانكه',
        'باوجوداينكه',
        'باوجوديكه',
        'باورند',
        'بايد',
        'بايستي',
        'بتازگي',
        'بتدريج',
        'بتمامي',
        'بجا',
        'بجاي',
        'بجز',
        'بخاطر',
        'بخاطراينكه',
        'بخردانه',
        'بخشه',
        'بخصوص',
        'بخوبي',
        'بد',
        'بدان',
        'بدانجا',
        'بدانها',
        'بدبينانه',
        'بدخواهانه',
        'بدرستي',
        'بدرشتي',
        'بدلخواه',
        'بدون',
        'بدين',
        'بدينجا',
        'بدينسان',
        'بر',
        'برا',
        'براثر',
        'براساس',
        'براستي',
        'بران',
        'برانند',
        'برانهاست',
        'براي',
        'برايت',
        'برايش',
        'برايشان',
        'برايم',
        'برايمان',
        'برحسب',
        'برخلاف',
        'برخوردارند',
        'برخي',
        'برداشتن',
        'بردن',
        'برروي',
        'برعكس',
        'برغم',
        'برمي',
        'برنمي',
        'برو',
        'بروشني',
        'برپا',
        'بزعم',
        'بزودي',
        'بس',
        'بسا',
        'بسادگي',
        'بسته',
        'بسختي',
        'بسرعت',
        'بسهولت',
        'بسوي',
        'بسي',
        'بسيار',
        'بسياري',
        'بشان',
        'بشدت',
        'بصورت',
        'بطبع',
        'بطور',
        'بطوركلي',
        'بطوري',
        'بطوريكه',
        'بعد',
        'بعدا',
        'بعداز',
        'بعدازان',
        'بعدازاين',
        'بعدازظهر',
        'بعدها',
        'بعدي',
        'بعضي',
        'بعضيشان',
        'بعضيها',
        'بعضيهاشان',
        'بعضيهايشان',
        'بعلاوه',
        'بعيد',
        'بفهمي',
        'بقدري',
        'بكار',
        'بكرات',
        'بلادرنگ',
        'بلافاصله',
        'بلكه',
        'بله',
        'بمراتب',
        'بموجب',
        'بموقع',
        'بنابراين',
        'بنابه',
        'بناچار',
        'بندرت',
        'به',
        'بهت',
        'بهتر',
        'بهرحال',
        'بهش',
        'بهيچ',
        'بود',
        'بودن',
        'بوضوح',
        'بويژه',
        'بي',
        'بيرون',
        'بيش',
        'بيشتر',
        'بين',
        'بينابين',
        'بيهوده',
        'بيگمان',
        'بپا',
        'بگرمي',
        'ت',
        'تا',
        'تاانجا',
        'تاانجاكه',
        'تاانكه',
        'تااينجا',
        'تااينكه',
        'تابه',
        'تاجاييكه',
        'تاحدودي',
        'تاحدي',
        'تازه',
        'تازگي',
        'تاكنون',
        'تاوقتي',
        'تاوقتيكه',
        'تحت',
        'تدريج',
        'تدريجا',
        'تدريجي',
        'تر',
        'ترتيب',
        'ترجيحا',
        'ترديد',
        'ترند',
        'تري',
        'ترين',
        'تصريحا',
        'تعدادي',
        'تعمدا',
        'تفاوت',
        'تفاوتند',
        'تفنني',
        'تقريبا',
        'تك',
        'تلويحا',
        'تمام',
        'تماما',
        'تمامشان',
        'تمامي',
        'تند',
        'تنها',
        'تنهايي',
        'تنگاتنگ',
        'تو',
        'توسط',
        'تووما',
        'توي',
        'تويي',
        'ث',
        'ثالثا',
        'ثاني',
        'ثانيا',
        'ج',
        'جا',
        'جاي',
        'جايي',
        'جبرگرايانه',
        'جدا',
        'جدااز',
        'جداازهم',
        'جداگانه',
        'جدي',
        'جديدا',
        'جرمزاست',
        'جز',
        'جزجز',
        'جسورانه',
        'جلو',
        'جلوتر',
        'جلوي',
        'جمع',
        'جمعا',
        'جمعي',
        'جنابعالي',
        'جنس',
        'جهت',
        'جور',
        'جوري',
        'ح',
        'حاشا',
        'حاشاوكلا',
        'حاشيه',
        'حاضر',
        'حاضرم',
        'حاكيست',
        'حال',
        'حالا',
        'حالكه',
        'حالي',
        'حتما',
        'حتي',
        'حداقل',
        'حداكثر',
        'حدود',
        'حرف',
        'حسابي',
        'حسابگرانه',
        'حسب',
        'حضرتعالي',
        'حقيرانه',
        'حقيقتا',
        'حكما',
        'حكيمانه',
        'حول',
        'خ',
        'خالص',
        'خالصانه',
        'خالي',
        'خام',
        'خامسا',
        'خب',
        'خداحافظ',
        'خداست',
        'خداگونه',
        'خردمندانه',
        'خسته',
        'خشمگين',
        'خصمانه',
        'خصوصا',
        'خلاقانه',
        'خواسته',
        'خواه',
        'خواهد',
        'خوب',
        'خوبتر',
        'خوبست',
        'خوبي',
        'خود',
        'خوداند',
        'خوداگاهانه',
        'خودبه',
        'خودت',
        'خودتان',
        'خودتو',
        'خودرا',
        'خودش',
        'خودشان',
        'خودم',
        'خودمان',
        'خودمختارانه',
        'خودمو',
        'خودنمايانه',
        'خودي',
        'خوش',
        'خوشبختانه',
        'خوشبينانه',
        'خوشحال',
        'خويش',
        'خويشتنم',
        'خوگيرانه',
        'خير',
        'خيره',
        'خيلي',
        'د',
        'دا',
        'داام',
        'دااما',
        'داخل',
        'دادن',
        'دارا',
        'داراست',
        'داراي',
        'دارد',
        'داشتن',
        'داوطلبانه',
        'دايم',
        'دايما',
        'دخترانه',
        'دراثر',
        'درازا',
        'درازاي',
        'دران',
        'دراين',
        'درباب',
        'درباره',
        'دربدر',
        'دربر',
        'دربرابر',
        'دربه',
        'درتخت',
        'درثاني',
        'درحال',
        'درحالي',
        'درحاليكه',
        'دردكشان',
        'درراستاي',
        'درست',
        'درسته',
        'درشت',
        'درشتي',
        'درصورتي',
        'درصورتيكه',
        'درطي',
        'درعين',
        'دركل',
        'دركنار',
        'درمجموع',
        'درمقابل',
        'درمورد',
        'درميان',
        'درنتيجه',
        'درنهايت',
        'درهر',
        'درهرحال',
        'درهرصورت',
        'درواقع',
        'دريغ',
        'دريغا',
        'درپي',
        'دسته',
        'دشمنيم',
        'دشوار',
        'دشوارتر',
        'دقيق',
        'دقيقا',
        'دلخواه',
        'دلخوش',
        'دلشاد',
        'دم',
        'دهد',
        'دو',
        'دوباره',
        'دوتا',
        'دوتادوتا',
        'دور',
        'دوراز',
        'دورتر',
        'دوساله',
        'دوستانه',
        'دوم',
        'دير',
        'ديرت',
        'ديرم',
        'ديروز',
        'ديروزبه',
        'ديشب',
        'ديوانه',
        'ديوي',
        'ديگر',
        'ديگران',
        'ديگرتا',
        'ديگري',
        'ديگه',
        'دگربار',
        'دگرباره',
        'دگرگون',
        'ذ',
        'ذاتا',
        'ذالك',
        'ذيل',
        'ذيلا',
        'ر',
        'را',
        'رااز',
        'رابه',
        'راجع',
        'راحت',
        'راحتر',
        'رادر',
        'راسا',
        'راست',
        'راستا',
        'راستي',
        'رسما',
        'رشته',
        'رغم',
        'رفتارهاست',
        'رنجند',
        'رندانه',
        'رهگشاست',
        'رو',
        'رواست',
        'روبرو',
        'روبروست',
        'روبه',
        'روز',
        'روزانه',
        'روزبروز',
        'روزمره',
        'روش',
        'روشن',
        'روشني',
        'روي',
        'رويش',
        'رياكارانه',
        'ريز',
        'ريزان',
        'ز',
        'زد',
        'زدن',
        'زده',
        'زشت',
        'زماني',
        'زنند',
        'زهي',
        'زو',
        'زود',
        'زودتر',
        'زودي',
        'زياد',
        'زيادتر',
        'زياده',
        'زيبا',
        'زيباتر',
        'زير',
        'زيرا',
        'زيراكه',
        'زيركانه',
        'زيرند',
        'زيرچشمي',
        'زين',
        'س',
        'سابقا',
        'ساختن',
        'ساده',
        'سادگي',
        'سازان',
        'سازهاست',
        'سازي',
        'سازگارانه',
        'ساكنند',
        'سالانه',
        'سالته',
        'سالم',
        'سالهاست',
        'ساليانه',
        'ساير',
        'سايران',
        'سايرين',
        'ست',
        'سخت',
        'سختتر',
        'سخته',
        'سر',
        'سراسر',
        'سرانجام',
        'سراپا',
        'سري',
        'سريع',
        'سريعا',
        'سعادتمندانه',
        'سنگدلانه',
        'سنگين',
        'سه',
        'سهوا',
        'سوم',
        'سياه',
        'سيخ',
        'سپس',
        'ش',
        'شااالله',
        'شاد',
        'شادتر',
        'شادمان',
        'شاكله',
        'شان',
        'شاهدند',
        'شاهديم',
        'شايد',
        'شبانه',
        'شبهاست',
        'شتابان',
        'شتابزده',
        'شجاعانه',
        'شخصا',
        'شد',
        'شدت',
        'شدن',
        'شده',
        'شديدا',
        'شما',
        'شماري',
        'شماست',
        'شمايند',
        'شود',
        'شوراست',
        'شوقم',
        'شيرين',
        'شيرينه',
        'شيك',
        'ص',
        'صادقانه',
        'صاف',
        'صد',
        'صدالبته',
        'صددرصد',
        'صراحتا',
        'صرفا',
        'صريح',
        'صريحا',
        'صريحتر',
        'صميمانه',
        'صندوق',
        'ض',
        'ضرورتا',
        'ضعيف',
        'ضعيفتر',
        'ضمن',
        'ضمنا',
        'ط',
        'طبعا',
        'طبيعتا',
        'طلبكارانه',
        'طور',
        'طوري',
        'طي',
        'ظ',
        'ظاهرا',
        'ع',
        'عاجزانه',
        'عادلانه',
        'عاقبت',
        'عاقلانه',
        'عالمانه',
        'عالي',
        'عبارتند',
        'عجب',
        'عجولانه',
        'عرفاني',
        'عزيز',
        'عقب',
        'عقبتر',
        'علاوه',
        'علنا',
        'عليرغم',
        'عليه',
        'عمدا',
        'عمدتا',
        'عمده',
        'عمدي',
        'عملا',
        'عملي',
        'عملگرايانه',
        'عموم',
        'عموما',
        'عميقا',
        'عن',
        'عنقريب',
        'عينا',
        'غ',
        'غالبا',
        'غزالان',
        'غير',
        'غيراز',
        'غيرازان',
        'غيرازاين',
        'غيرتصادفي',
        'غيرطبيعي',
        'غيرعمدي',
        'غيرمستقيم',
        'غيريكسان',
        'ف',
        'فاقد',
        'فبها',
        'فر',
        'فراتر',
        'فراتراز',
        'فراوان',
        'فردا',
        'فعالانه',
        'فعلا',
        'فقط',
        'فكورانه',
        'فلان',
        'فلذا',
        'فناورانه',
        'فهرستوار',
        'فورا',
        'فوري',
        'فوق',
        'ق',
        'قاالند',
        'قابل',
        'قاطبه',
        'قاطعانه',
        'قاعدتا',
        'قانونا',
        'قبل',
        'قبلا',
        'قبلند',
        'قد',
        'قدر',
        'قدرمسلم',
        'قدري',
        'قرار',
        'قراردادن',
        'قريب',
        'قضاياست',
        'قطعا',
        'قيلا',
        'ك',
        'كارافرينانه',
        'كاربرمدارانه',
        'كارند',
        'كاش',
        'كاشكي',
        'كاملا',
        'كاملتر',
        'كان',
        'كاين',
        'كجا',
        'كجاست',
        'كدام',
        'كدامند',
        'كداميك',
        'كرات',
        'كرد',
        'كردن',
        'كرده',
        'كز',
        'كزين',
        'كس',
        'كساني',
        'كسي',
        'كشيدن',
        'كل',
        'كلا',
        'كلي',
        'كليشه',
        'كم',
        'كمااينكه',
        'كمابيش',
        'كماكان',
        'كمتر',
        'كمتره',
        'كمي',
        'كنار',
        'كنارش',
        'كنان',
        'كنايه',
        'كند',
        'كنم',
        'كنند',
        'كننده',
        'كه',
        'كودكانه',
        'كوركورانه',
        'كي',
        'كيست',
        'ل',
        'لا',
        'لااقل',
        'لاجرم',
        'لب',
        'لذا',
        'لزوما',
        'لطفا',
        'ليكن',
        'م',
        'ما',
        'مات',
        'مادام',
        'مادامي',
        'ماداميكه',
        'ماست',
        'ماشينوار',
        'ماقبل',
        'مالا',
        'مالامال',
        'مامان',
        'مانند',
        'ماهرانه',
        'ماهيتا',
        'مايي',
        'مبادا',
        'متاسفانه',
        'متعاقبا',
        'متفاوتند',
        'متفكرانه',
        'متقابلا',
        'متوالي',
        'متوسفانه',
        'مثابه',
        'مثل',
        'مثلا',
        'مجبورند',
        'مجددا',
        'مجرمانه',
        'مجموع',
        'مجموعا',
        'محتاجند',
        'محتاط',
        'محتاطانه',
        'محكم',
        'مخالفند',
        'مختصر',
        'مختصرا',
        'مخصوصا',
        'مدام',
        'مداوم',
        'مدبر',
        'مدبرانه',
        'مدتهاست',
        'مدتي',
        'مرا',
        'مراتب',
        'مرتب',
        'مرتبا',
        'مردانه',
        'مستحضريد',
        'مستعد',
        'مستقلا',
        'مستقيم',
        'مستقيما',
        'مستمر',
        'مستمرا',
        'مستند',
        'مسلم',
        'مسلما',
        'مسيولانه',
        'مشت',
        'مشتركا',
        'مشخص',
        'مشغول',
        'مشغولند',
        'مشكل',
        'مشكلتر',
        'مطلق',
        'مطلقا',
        'مطمانا',
        'مطمانم',
        'مطمنا',
        'مع',
        'معتقدم',
        'معتقدند',
        'معتقديم',
        'معدود',
        'معذوريم',
        'معلق',
        'معلومه',
        'معمولا',
        'معمولي',
        'مغرضانه',
        'مغلوب',
        'مفيدند',
        'مقدار',
        'مقصر',
        'مقصري',
        'مقلوب',
        'مكرر',
        'مكررا',
        'ملزم',
        'مميزيهاست',
        'من',
        'منتهي',
        'منحصر',
        'منحصرا',
        'منحصربفرد',
        'منصفانه',
        'منطقا',
        'منطقي',
        'مني',
        'مواجهند',
        'موجب',
        'موجودند',
        'موخر',
        'مورد',
        'موقعيكه',
        'مي',
        'ميان',
        'ميزان',
        'مگر',
        'مگرانكه',
        'مگراينكه',
        'ن',
        'نااميد',
        'نااگاهانه',
        'ناتوان',
        'ناخواسته',
        'ناخوانده',
        'ناديده',
        'ناراضي',
        'ناسازگارانه',
        'ناشناخته',
        'ناكام',
        'ناهشيار',
        'ناپذير',
        'ناچار',
        'ناگزير',
        'ناگهان',
        'نبايد',
        'نبش',
        'نتيجتا',
        'نخست',
        'نخودي',
        'ندارد',
        'ندرت',
        'ندرتا',
        'نرم',
        'نرمي',
        'نزد',
        'نزديك',
        'نزديكتر',
        'نسبت',
        'نظرا',
        'نظربه',
        'نظير',
        'نفرند',
        'نفهمي',
        'نقادانه',
        'نمي',
        'نه',
        'نهان',
        'نهايت',
        'نهايتا',
        'نواورانه',
        'نوع',
        'نوعا',
        'نوميد',
        'نيازمندانه',
        'نيازمندند',
        'نيز',
        'نيست',
        'نيك',
        'نيمي',
        'ه',
        'ها',
        'هاست',
        'هان',
        'هايي',
        'هدف',
        'هر',
        'هرازچندگاهي',
        'هرانچه',
        'هرجا',
        'هرزچندگاهي',
        'هرساله',
        'هرقدر',
        'هركدام',
        'هركس',
        'هركسي',
        'هركه',
        'هروقت',
        'هرچقدر',
        'هرچند',
        'هرچه',
        'هرگاه',
        'هرگز',
        'هرگونه',
        'هزارها',
        'هست',
        'هستند',
        'هشيارانه',
        'هق',
        'هم',
        'همان',
        'همانا',
        'همانطور',
        'همانطوركه',
        'همانطوري',
        'همانطوريكه',
        'همانقدر',
        'همانند',
        'همانها',
        'هماني',
        'هماهنگتر',
        'همخوان',
        'همدلانه',
        'همديگر',
        'همزمان',
        'همسو',
        'همسوبا',
        'همكارانه',
        'همنوا',
        'همه',
        'همواره',
        'همي',
        'هميشه',
        'هميشگي',
        'همين',
        'همينطور',
        'همينطوركه',
        'همينطوري',
        'همينطوريكه',
        'همينكه',
        'همچنان',
        'همچنانكه',
        'همچنين',
        'همچون',
        'همچين',
        'همگام',
        'همگان',
        'همگي',
        'هنوز',
        'هنگاميكه',
        'هوشمندانه',
        'هوشيارانه',
        'هوي',
        'هي',
        'هيچ',
        'هيچكدام',
        'هيچكس',
        'هيچي',
        'هيچيك',
        'هيچگاه',
        'هيچگونه',
        'وابسته',
        'واضح',
        'واضحتر',
        'واقع',
        'واقعا',
        'واقعي',
        'واقفند',
        'واي',
        'وجه',
        'وجود',
        'وجوديكه',
        'وحشت',
        'ور',
        'ورا',
        'وراي',
        'وزو',
        'وضوح',
        'وقتي',
        'وقتيكه',
        'ولي',
        'وليكن',
        'وهمين',
        'وي',
        'ويا',
        'ويژه',
        'وگر',
        'وگرنه',
        'يا',
        'يااز',
        'ياانكه',
        'يااينكه',
        'يابد',
        'يارب',
        'يافتن',
        'يعني',
        'يقينا',
        'يك',
        'يكايك',
        'يكبار',
        'يكباره',
        'يكجا',
        'يكجانبه',
        'يكجور',
        'يكجوري',
        'يكدم',
        'يكديگر',
        'يكريز',
        'يكزمان',
        'يكسال',
        'يكسره',
        'يكسري',
        'يكطرفه',
        'يكنواخت',
        'يكي',
        'يكپارچه',
        'يه',
        'يواش',
        'پ',
        'پارسال',
        'پارسايانه',
        'پاره',
        'پايين',
        'پدرانه',
        'پدرپي',
        'پديده',
        'پذير',
        'پذيرند',
        'پراكنده',
        'پرتحرك',
        'پرخاشگرانه',
        'پرسان',
        'پرشتاب',
        'پرشور',
        'پروردگارا',
        'پريروز',
        'پس',
        'پشت',
        'پشتوانه',
        'پشيموني',
        'پنهان',
        'پهن',
        'پي',
        'پيامبرانه',
        'پيداست',
        'پيدرپي',
        'پيرامون',
        'پيش',
        'پيشاپيش',
        'پيشتر',
        'پيوسته',
        'پيگير',
        'چ',
        'چارده',
        'چاله',
        'چاپلوسانه',
        'چت',
        'چته',
        'چرا',
        'چراكه',
        'چطور',
        'چقدر',
        'چكار',
        'چنان',
        'چنانكه',
        'چنانچه',
        'چند',
        'چندان',
        'چنداني',
        'چندروزه',
        'چندماهه',
        'چندمين',
        'چنده',
        'چندين',
        'چنين',
        'چه',
        'چهارهزار',
        'چو',
        'چون',
        'چي',
        'چيز',
        'چيزهاست',
        'چيزيست',
        'چيست',
        'چيه',
        'چگونه',
        'ژ',
        'گ',
        'گاه',
        'گاهي',
        'گذاران',
        'گذاري',
        'گذاشتن',
        'گر',
        'گرديد',
        'گرفتارند',
        'گرفتن',
        'گرمي',
        'گرنه',
        'گرچه',
        'گفت',
        'گمان',
        'گهگاه',
        'گونه',
        'گويا',
        'گويان',
        'گويي',
        'ابلهانه ها',
        '?',
        '',
        ':',
        'و',
        'NULL',
        'در',
        'به',
        'از',
        'كه',
        'مي',
        'اين',
        'است',
        'را',
        'با',
        'هاي',
        'براي',
        'آن',
        'يك',
        'شود',
        'شده',
        'خود',
        'ها',
        'كرد',
        'شد',
        'اي',
        'تا',
        'كند',
        'بر',
        'بود',
        'گفت',
        'نيز',
        'وي',
        'هم',
        'كنند',
        'دارد',
        'ما',
        'كرده',
        'يا',
        'اما',
        'بايد',
        'دو',
        'اند',
        'هر',
        'خواهد',
        'او',
        'مورد',
        'آنها',
        'باشد',
        'ديگر',
        'مردم',
        'نمي',
        'بين',
        'پيش',
        'پس',
        'اگر',
        'همه',
        'صورت',
        'يكي',
        'هستند',
        'بي',
        'من',
        'دهد',
        'هزار',
        'نيست',
        'استفاده',
        'داد',
        'داشته',
        'داشت',
        'چه',
        'همچنين',
        'كردند',
        'داده',
        'بوده',
        'دارند',
        'همين',
        'ميليون',
        'سوي',
        'شوند',
        'بيشتر',
        'بسيار',
        'روي',
        'گرفته',
        'هايي',
        'تواند',
        'اول',
        'نام',
        'هيچ',
        'چند',
        'جديد',
        'بيش',
        'شدن',
        'كردن',
        'كنيم',
        'نشان',
        'حتي',
        'اينكه',
        'ول?',
        'توسط',
        'چنين',
        'برخي',
        'نه',
        'ديروز',
        'دوم',
        'درباره',
        'بعد',
        'مختلف',
        'گيرد',
        'شما',
        'گفته',
        'آنان',
        'بار',
        'طور',
        'گرفت',
        'دهند',
        'گذاري',
        'بسياري',
        'طي',
        'بودند',
        'ميليارد',
        'بدون',
        'تمام',
        'كل',
        'تر',
        'براساس',
        'شدند',
        'ترين',
        'امروز',
        'باشند',
        'ندارد',
        'چون',
        'قابل',
        'گويد',
        'ديگري',
        'همان',
        'خواهند',
        'قبل',
        'آمده',
        'اكنون',
        'تحت',
        'طريق',
        'گيري',
        'جاي',
        'هنوز',
        'چرا',
        'البته',
        'كنيد',
        'سازي',
        'سوم',
        'كنم',
        'بلكه',
        'زير',
        'توانند',
        'ضمن',
        'فقط',
        'بودن',
        'حق',
        'آيد',
        'وقتي',
        'اش',
        'يابد',
        'نخستين',
        'مقابل',
        'خدمات',
        'امسال',
        'تاكنون',
        'مانند',
        'تازه',
        'آورد',
        'فكر',
        'آنچه',
        'نخست',
        'نشده',
        'شايد',
        'چهار',
        'جريان',
        'پنج',
        'ساخته',
        'زيرا',
        'نزديك',
        'برداري',
        'كسي',
        'ريزي',
        'رفت',
        'گردد',
        'مثل',
        'آمد',
        'ام',
        'بهترين',
        'دانست',
        'كمتر',
        'دادن',
        'تمامي',
        'جلوگيري',
        'بيشتري',
        'ايم',
        'ناشي',
        'چيزي',
        'آنكه',
        'بالا',
        'بنابراين',
        'ايشان',
        'بعضي',
        'دادند',
        'داشتند',
        'برخوردار',
        'نخواهد',
        'هنگام',
        'نبايد',
        'غير',
        'نبود',
        'ديده',
        'وگو',
        'داريم',
        'چگونه',
        'بندي',
        'خواست',
        'فوق',
        'ده',
        'نوعي',
        'هستيم',
        'ديگران',
        'همچنان',
        'سراسر',
        'ندارند',
        'گروهي',
        'سعي',
        'روزهاي',
        'آنجا',
        'يكديگر',
        'كردم',
        'بيست',
        'بروز',
        'سپس',
        'رفته',
        'آورده',
        'نمايد',
        'باشيم',
        'گويند',
        'زياد',
        'خويش',
        'همواره',
        'گذاشته',
        'شش',
        'نداشته',
        'شناسي',
        'خواهيم',
        'آباد',
        'داشتن',
        'نظير',
        'همچون',
        'باره',
        'نكرده',
        'شان',
        'سابق',
        'هفت',
        'دانند',
        'جايي',
        'ب?',
        'جز',
        'ز?رِ',
        'رو?ِ',
        'سر?ِ',
        'تو?ِ',
        'جلو?ِ',
        'پ?شِ',
        'عقبِ',
        'بالا?ِ',
        'خارجِ',
        'وسطِ',
        'ب?رونِ',
        'سو?ِ',
        'كنارِ',
        'پاع?نِ',
        'نزدِ',
        'نزد?كِ',
        'دنبالِ',
        'حدودِ',
        'برابرِ',
        'طبقِ',
        'مانندِ',
        'ضدِّ',
        'هنگامِ',
        'برا?ِ',
        'مثلِ',
        'بارة',
        'اثرِ',
        'تولِ',
        'علّتِ',
        'سمتِ',
        'عنوانِ',
        'قصدِ',
        'روب',
        'جدا',
        'ك?',
        'كه',
        'چ?ست',
        'هست',
        'كجا',
        'كجاست',
        'كَ?',
        'چطور',
        'كدام',
        'آ?ا',
        'مگر',
        'چند?ن',
        '?ك',
        'چ?ز?',
        'د?گر',
        'كس?',
        'بعر?',
        'ه?چ',
        'چ?ز',
        'جا',
        'كس',
        'هرگز',
        '?ا',
        'تنها',
        'بلكه',
        'خ?اه',
        'بله',
        'بل?',
        'آره',
        'آر?',
        'مرس?',
        'البتّه',
        'لطفاً',
        'ّه',
        'انكه',
        'وقت?كه',
        'هم?ن',
        'پ?ش',
        'مدّت?',
        'هنگام?',
        'مان',
        'تان',
        '?',
        'ور',
        'هممون',
        'و?',
        'كنن   ',
        'كنند   ',
        'م?‌كنند   ',
        'م?‌كنن   ',
        'هممون   ',
        'نزد?م   ',
        'نم?مون?د   ',
        'دارا?',
        'خود?',
        'وگرد',
        'همانند',
        'بشوند',
        'نم?‌كنند   ',
        'انها',
        'بازم',
        'پ?ششون   ',
        '?گرد?   ',
        'ونن',
        'رو?م',
        'ابدا',
        'عمدتا',
        'بند?',
        'م?‌گن   ',
        'مند',
        'آخه',
        'آورده   ',
        'رابس?ار   ',
        'م?‌باشد   ',
        'ساخته‌ام   ',
        'م?‌گردد   ',
        'درباره   ',
        'وبرا?   ',
        'م?‌ده?م  ',
        'خو?ش',
        'دوباره‌ا?',
        'پراز',
        'هشان',
        'بتوان',
        'م?‌نوشند',
        'نر?م',
        'ند?د?',
        'داشتند',
        'بخوب?',
        'م?‌خواستن',
        'در',
        'تو?',
        'با',
        'كه',
        'به',
        'تو',
        'شد',
        'را ',
        'شده',
        'است',
        'هم',
        'از',
        'نم?‌گ?رند',
        'ب?ن',
        'ب?نمان',
        'مهمتره',
        'ب?ار?م',
        'واسش',
        'بده?د',
        'نكنند',
        'گذار?',
        'ماا',
        'نم?‌اورم',
        'خاست',
        'رفته‌ام',
        'نم?‌اورم',
        'ها?ت',
        'نم?‌برد',
        'همچنانكه',
        'بش?د',
        'نم?‌روم',
        'تان',
        'نم?مون?د',
        'هممون',
        'ور',
        'تنها',
        'م?‌خواهند',
        'دچار',
        'شناس?د',
        'خود?',
        'وگرد',
        'بوجود',
        'همانند',
        'دارا?',
        'بر?ز?د',
        'بشم',
        'كنه',
        'كنيم',
        'ي',
        'كنند',
        'و',
        'كني',
        'ميكنم',
        'كنم',
        'م?',
        'ا?ن',
        'داره',
        'چي',
        'تون',
        'بهم',
        'بعدا',
        'هاش',
        'بشي',
        'ميكند',
        'كرده',
        'ا?د',
        'گرچه',
        'ازش',
        'ميكنه',
        'مي‌رم',
        'كنه',
        'كرد',
        'باشه',
        'دون?د',
        'يك',
        'بگيرم',
        'شديد',
        'بزنيد',
        'نشون',
        'روى',
        'رسيد',
        'بشن',
        'بري',
        'دارم',
        'الي',
        'گه',
        'اينطوري',
        'كلي',
        'تونست',
        'دارم',
        'يه',
        'نداره',
        'بياد',
        'جور',
        'كرده',
        'بودم',
        'توي',
        'كرديد',
        'هستن',
        'اون',
        'ميشه',
        'شو',
        'بشم',
        'بريد',
        'بريم',
        'بود?د',
        'چيه',
        'باشه',
        'واقعا',
        'رو',
        'هست?د',
        'اينجا',
        'وارد',
        'توش',
        'اينكه',
        'آيا',
        'بدم',
        'باشه',
        'بهشون',
        'يعني',
        'مون',
        'شرط',
        'اينا',
        'كردم',
        'بدان',
        'نباش',
        'نداد',
        'مي‌كنن',
        'كردن',
        'كرده',
        'اون',
        'ميرن',
        'شديم',
        'برا?',
        'ميكنيم',
        'كن?م',
        'خودم',
        '،',
        'ى',
        'علارغم',
        '،',
        'نميكنن',
        'ميروم',
        'اونجا',
        '.',
        'اونا',
        'اه',
        'اينجور',
        'ات',
        'خواهيمكرد',
        'مي‌گيره',
        'ميدهم',
        'خيلي',
        'م?‌كنند',
        'كنن',
        'نكنه',
        '؟',
        '?',
        'م?‌كند',
        'شده‌اند',
        'باشم',
        'نا',
        'حت?',
        'م?‌داد',
        'م?‌شوند',
        'كردند',
        'م?‌كنم',
        'م?‌دهد',
        'كرديم',
        'كنيد',
        '_',
        'براى',
        'ها?',
        'ها?a',
        '؛',
        '،',
        '.',
        '…',
        '',
        'و',
        'در',
        'به',
        'از',
        'كه',
        'مي',
        'اين',
        'است',
        'را',
        'با',
        'هاي',
        'براي',
        'آن',
        'يك',
        'شود',
        'شده',
        'خود',
        'ها',
        'كرد',
        'شد',
        'اي',
        'تا',
        'كند',
        'بر',
        'بود',
        'گفت',
        'نيز',
        'وي',
        'هم',
        'كنند',
        'دارد',
        'ما',
        'كرده',
        'يا',
        'اما',
        'بايد',
        'دو',
        'اند',
        'هر',
        'خواهد',
        'او',
        'مورد',
        'آنها',
        'باشد',
        'ديگر',
        'مردم',
        'نمي',
        'بين',
        'پيش',
        'پس',
        'اگر',
        'همه',
        'صورت',
        'يكي',
        'هستند',
        'بي',
        'من',
        'دهد',
        'هزار',
        'نيست',
        'استفاده',
        'داد',
        'داشته',
        'داشت',
        'چه',
        'همچنين',
        'كردند',
        'داده',
        'بوده',
        'دارند',
        'همين',
        'ميليون',
        'سوي',
        'شوند',
        'بيشتر',
        'بسيار',
        'روي',
        'گرفته',
        'هايي',
        'تواند',
        'اول',
        'نام',
        'هيچ',
        'چند',
        'جديد',
        'بيش',
        'شدن',
        'كردن',
        'كنيم',
        'نشان',
        'حتي',
        'اينكه',
        'ولی',
        'توسط',
        'چنين',
        'برخي',
        'نه',
        'ديروز',
        'دوم',
        'درباره',
        'بعد',
        'مختلف',
        'گيرد',
        'شما',
        'گفته',
        'آنان',
        'بار',
        'طور',
        'گرفت',
        'دهند',
        'گذاري',
        'بسياري',
        'طي',
        'بودند',
        'ميليارد',
        'بدون',
        'تمام',
        'كل',
        'تر	براساس',
        'شدند',
        'ترين',
        'امروز',
        'باشند',
        'ندارد',
        'چون',
        'قابل',
        'گويد',
        'ديگري',
        'همان',
        'خواهند',
        'قبل',
        'آمده',
        'اكنون',
        'تحت',
        'طريق',
        'گيري',
        'جاي',
        'هنوز',
        'چرا',
        'البته',
        'كنيد',
        'سازي',
        'سوم',
        'كنم',
        'بلكه',
        'زير',
        'توانند',
        'ضمن',
        'فقط',
        'بودن',
        'حق',
        'آيد',
        'وقتي',
        'اش',
        'يابد',
        'نخستين',
        'مقابل',
        'خدمات',
        'امسال',
        'تاكنون',
        'مانند',
        'تازه',
        'آورد',
        'فكر',
        'آنچه',
        'نخست',
        'نشده',
        'شايد',
        'چهار',
        'جريان',
        'پنج',
        'ساخته',
        'زيرا',
        'نزديك',
        'برداري',
        'كسي',
        'ريزي',
        'رفت',
        'گردد',
        'مثل',
        'آمد',
        'ام',
        'بهترين',
        'دانست',
        'كمتر',
        'دادن',
        'تمامي',
        'جلوگيري',
        'بيشتري',
        'ايم',
        'ناشي',
        'چيزي',
        'آنكه',
        'بالا',
        'بنابراين',
        'ايشان',
        'بعضي',
        'دادند',
        'داشتند',
        'برخوردار',
        'نخواهد',
        'هنگام',
        'نبايد',
        'غير',
        'نبود',
        'ديده',
        'وگو',
        'داريم',
        'چگونه',
        'بندي',
        'خواست',
        'فوق',
        'ده',
        'نوعي',
        'هستيم',
        'ديگران',
        'همچنان',
        'سراسر',
        'ندارند',
        'گروهي',
        'سعي',
        'روزهاي',
        'آنجا',
        'يكديگر',
        'كردم',
        'بيست',
        'بروز',
        'سپس',
        'رفته',
        'آورده',
        'نمايد',
        'باشيم',
        'گويند',
        'زياد',
        'خويش',
        'همواره',
        'گذاشته',
        'شش	نداشته',
        'شناسي',
        'خواهيم',
        'آباد',
        'داشتن',
        'نظير',
        'همچون',
        'باره',
        'نكرده',
        'شان',
        'سابق',
        'هفت',
        'دانند',
        'جايي',
        'بی',
        'جز',
        'زیرِ',
        'رویِ',
        'سریِ',
        'تویِ',
        'جلویِ',
        'پیشِ',
        'عقبِ',
        'بالایِ',
        'خارجِ',
        'وسطِ',
        'بیرونِ',
        'سویِ',
        'کنارِ',
        'پاعینِ',
        'نزدِ',
        'نزدیکِ',
        'دنبالِ',
        'حدودِ',
        'برابرِ',
        'طبقِ',
        'مانندِ',
        'ضدِّ',
        'هنگامِ',
        'برایِ',
        'مثلِ',
        'بارة',
        'اثرِ',
        'تولِ',
        'علّتِ',
        'سمتِ',
        'عنوانِ',
        'قصدِ',
        'روب',
        'جدا',
        'کی',
        'که',
        'چیست',
        'هست',
        'کجا',
        'کجاست',
        'کَی',
        'چطور',
        'کدام',
        'آیا',
        'مگر',
        'چندین',
        'یک',
        'چیزی',
        'دیگر',
        'کسی',
        'بعری',
        'هیچ',
        'چیز',
        'جا',
        'کس',
        'هرگز',
        'یا',
        'تنها',
        'بلکه',
        'خیاه',
        'بله',
        'بلی',
        'آره',
        'آری',
        'مرسی',
        'البتّه',
        'لطفاً',
        'ّه',
        'انکه',
        'وقتیکه',
        'همین',
        'پیش',
        'مدّتی',
        'هنگامی',
        'مان',
        'تان',
        '!',
        '"',
        '#',
        '(',
        ')',
        '*',
        ',',
        '-',
        '.',
        '/',
        ':',
        '[',
        ']',
        '«',
        '»',
        '،',
        '؛',
        '؟',
        'آباد',
        'آخ',
        'آخر',
        'آخرها',
        'آخه',
        'آدمهاست',
        'آرام',
        'آرام آرام',
        'آره',
        'آری',
        'آزادانه',
        'آسان',
        'آسیب پذیرند',
        'آشنایند',
        'آشکارا',
        'آقا',
        'آقای',
        'آقایان',
        'آمد',
        'آمدن',
        'آمده',
        'آمرانه',
        'آن',
        'آن گاه',
        'آنان',
        'آنانی',
        'آنجا',
        'آنرا',
        'آنطور',
        'آنقدر',
        'آنها',
        'آنهاست',
        'آنچنان',
        'آنچنان که',
        'آنچه',
        'آنکه',
        'آنگاه',
        'آن‌ها',
        'آهان',
        '‌های',
        'آهای',
        'آور',
        'آورد',
        'آوردن',
        'آورده',
        'آوه',
        'آی',
        'آیا',
        'آید',
        'آیند',
        'ا',
        'اتفاقا',
        'اثرِ',
        'اجراست',
        'احتراما',
        'احتمالا',
        'احیاناً',
        'اخیر',
        'اخیراً',
        'اری',
        'از',
        'از آن پس',
        'از جمله',
        'ازاین رو',
        'ازجمله',
        'ازش',
        'اساسا',
        'اساساً',
        'است',
        'استفاد',
        'استفاده',
        'اسلامی اند',
        'اش',
        'اشتباها',
        'اشکارا',
        'اصلا',
        'اصلاً',
        'اصولا',
        'اصولاً',
        'اعلام',
        'اغلب',
        'افزود',
        'افسوس',
        'اقل',
        'اقلیت',
        'الا',
        'الان',
        'البته',
        'البتّه',
        'الهی',
        'الی',
        'ام',
        'اما',
        'امروز',
        'امروزه',
        'امسال',
        'امشب',
        'امور',
        'امیدوارم',
        'امیدوارند',
        'امیدواریم',
        'ان',
        'ان شاأالله',
        'انتها',
        'انجام',
        'اند',
        'اندکی',
        'انشاالله',
        'انصافا',
        'انطور',
        'انقدر',
        'انها',
        'انچنان',
        'انکه',
        'انگار',
        'او',
        'اوست',
        'اول',
        'اولا',
        'اولاً',
        'اولین',
        'اون',
        'اکثر',
        'اکثرا',
        'اکثراً',
        'اکثریت',
        'اکنون',
        'اگر',
        'اگر چه',
        'اگرچه',
        'اگه',
        'ای',
        'ایا',
        'اید',
        'ایشان',
        'ایم',
        'این',
        'این جوری',
        'این قدر',
        'این گونه',
        'اینان',
        'اینجا',
        'اینجاست',
        'ایند',
        'اینطور',
        'اینقدر',
        'اینها',
        'اینهاست',
        'اینو',
        'اینچنین',
        'اینک',
        'اینکه',
        'اینگونه',
        'ب ',
        'با',
        'بااین حال',
        'بااین وجود',
        'باد',
        'بار',
        'بارة',
        'باره',
        'بارها',
        'باز',
        'باز هم',
        'بازهم',
        'بازی کنان',
        'بازیگوشانه',
        'باش',
        'باشد',
        'باشم',
        'باشند',
        'باشی',
        'باشید',
        'باشیم',
        'بالا',
        'بالاخره',
        'بالاخص',
        'بالاست',
        'بالای',
        'بالایِ',
        'بالطبع',
        'بالعکس',
        'باوجودی که',
        'باورند',
        'باید',
        'بتدریج',
        'بتوان',
        'بتواند',
        'بتوانی',
        'بتوانیم',
        'بجز',
        'بخش',
        'بخشه',
        'بخشی',
        'بخصوص',
        'بخواه',
        'بخواهد',
        'بخواهم',
        'بخواهند',
        'بخواهی',
        'بخواهید',
        'بخواهیم',
        'بخوبی',
        'بد',
        'بدان',
        'بدانجا',
        'بدانها',
        'بدهید',
        'بدون',
        'بدین',
        'بدین ترتیب',
        'بدینجا',
        'بر',
        'برآنند',
        'برا',
        'برابر',
        'برابرِ',
        'براحتی',
        'براساس',
        'براستی',
        'برای',
        'برایت',
        'برایش',
        'برایشان',
        'برایم',
        'برایمان',
        'برایِ',
        'برخوردار',
        'برخوردارند',
        'برخی',
        'برداری',
        'برعکس',
        'برنامه سازهاست',
        'بروز',
        'بروشنی',
        'بزرگ',
        'بزودی',
        'بس',
        'بسا',
        'بسادگی',
        'بسختی',
        'بسوی',
        'بسی',
        'بسیار',
        'بسیاری',
        'بشدت',
        'بطور',
        'بطوری که',
        'بعد',
        'بعد از این که',
        'بعدا',
        'بعدازظهر',
        'بعداً',
        'بعدها',
        'بعری',
        'بعضا',
        'بعضی',
        'بعضی شان',
        'بعضیهایشان',
        'بعضی‌ها',
        'بعلاوه',
        'بعید',
        'بفهمی نفهمی',
        'بلافاصله',
        'بله',
        'بلکه',
        'بلی',
        'بماند',
        'بنابراین',
        'بندی',
        'به',
        'به آسانی',
        'به تازگی',
        'به تدریج',
        'به تمامی',
        'به جای',
        'به جز',
        'به خوبی',
        'به درشتی',
        'به دلخواه',
        'به راستی',
        'به رغم',
        'به روشنی',
        'به زودی',
        'به سادگی',
        'به سرعت',
        'به شان',
        'به شدت',
        'به طور کلی',
        'به طوری که',
        'به علاوه',
        'به قدری',
        'به مراتب',
        'به ناچار',
        'به هرحال',
        'به هیچ وجه',
        'به وضوح',
        'به ویژه',
        'به کرات',
        'به گرمی',
        'بهت',
        'بهتر',
        'بهترین',
        'بهش',
        'بود',
        'بودم',
        'بودن',
        'بودند',
        'بوده',
        'بودی',
        'بودید',
        'بودیم',
        'بویژه',
        'بپا',
        'بکار',
        'بکن',
        'بکند',
        'بکنم',
        'بکنند',
        'بکنی',
        'بکنید',
        'بکنیم',
        'بگذاریم',
        'بگو',
        'بگوید',
        'بگویم',
        'بگویند',
        'بگویی',
        'بگویید',
        'بگوییم',
        'بگیر',
        'بگیرد',
        'بگیرم',
        'بگیرند',
        'بگیری',
        'بگیرید',
        'بگیریم',
        'بی',
        'بی آنکه',
        'بی اطلاعند',
        'بی تردید',
        'بی تفاوتند',
        'بی نیازمندانه',
        'بی هدف',
        'بیا',
        'بیاب',
        'بیابد',
        'بیابم',
        'بیابند',
        'بیابی',
        'بیابید',
        'بیابیم',
        'بیاور',
        'بیاورد',
        'بیاورم',
        'بیاورند',
        'بیاوری',
        'بیاورید',
        'بیاوریم',
        'بیاید',
        'بیایم',
        'بیایند',
        'بیایی',
        'بیایید',
        'بیاییم',
        'بیرون',
        'بیرونِ',
        'بیست',
        'بیش',
        'بیشتر',
        'بیشتری',
        'بین',
        'بیگمان',
        'ت',
        'تا',
        'تازه',
        'تان',
        'تاکنون',
        'تحت',
        'تحریم هاست',
        'تر',
        'تر براساس',
        'تریلیارد',
        'تریلیون',
        'ترین',
        'تصریحاً',
        'تعدادی',
        'تعمدا',
        'تقریبا',
        'تقریباً',
        'تلویحا',
        'تلویحاً',
        'تمام',
        'تمام قد',
        'تماما',
        'تمامشان',
        'تمامی',
        'تند تند',
        'تنها',
        'تو',
        'توؤماً',
        'توان',
        'تواند',
        'توانست',
        'توانستم',
        'توانستن',
        'توانستند',
        'توانسته',
        'توانستی',
        'توانستیم',
        'توانم',
        'توانند',
        'توانی',
        'توانید',
        'توانیم',
        'توسط',
        'تولِ',
        'توی',
        'تویِ',
        'تک تک',
        'ث',
        'ثالثاً',
        'ثانیا',
        'ثانیاً',
        'ج',
        'جا',
        'جای',
        'جایی',
        'جدا',
        'جداً',
        'جداگانه',
        'جدید',
        'جدیدا',
        'جرمزاست',
        'جریان',
        'جز',
        'جلو',
        'جلوگیری',
        'جلوی',
        'جلویِ',
        'جمع اند',
        'جمعا',
        'جمعی',
        'جنابعالی',
        'جناح',
        'جنس اند',
        'جهت',
        'جور',
        'ح',
        'حاشیه‌ای',
        'حاضر',
        'حاضرم',
        'حال',
        'حالا',
        'حاکیست',
        'حتما',
        'حتماً',
        'حتی',
        'حداقل',
        'حداکثر',
        'حدود',
        'حدودا',
        'حدودِ',
        'حسابگرانه',
        'حضرتعالی',
        'حق',
        'حقیرانه',
        'حقیقتا',
        'حول',
        'حکماً',
        'خ',
        'خارجِ',
        'خالصانه',
        'خب',
        'خداحافظ',
        'خداست',
        'خدمات',
        'خسته‌ای',
        'خصوصا',
        'خصوصاً',
        'خلاصه',
        'خواست',
        'خواستم',
        'خواستن',
        'خواستند',
        'خواسته',
        'خواستی',
        'خواستید',
        'خواستیم',
        'خواه',
        'خواهد',
        'خواهم',
        'خواهند',
        'خواهی',
        'خواهید',
        'خواهیم',
        'خوب',
        'خود',
        'خود به خود',
        'خودبه خودی',
        'خودت',
        'خودتان',
        'خودتو',
        'خودش',
        'خودشان',
        'خودم',
        'خودمان',
        'خودمو',
        'خوش',
        'خوشبختانه',
        'خویش',
        'خویشتن',
        'خویشتنم',
        'خیاه',
        'خیر',
        'خیره',
        'خیلی',
        'د',
        'دا',
        'داام',
        'دااما',
        'داخل',
        'داد',
        'دادم',
        'دادن',
        'دادند',
        'داده',
        'دادی',
        'دادید',
        'دادیم',
        'دار',
        'داراست',
        'دارد',
        'دارم',
        'دارند',
        'داری',
        'دارید',
        'داریم',
        'داشت',
        'داشتم',
        'داشتن',
        'داشتند',
        'داشته',
        'داشتی',
        'داشتید',
        'داشتیم',
        'دامم',
        'دانست',
        'دانند',
        'دایم',
        'دایما',
        'در',
        'در باره',
        'در بارهٌ',
        'در ثانی',
        'در مجموع',
        'در نهایت',
        'در واقع',
        'در کل',
        'در کنار',
        'دراین میان',
        'درباره',
        'درحالی که',
        'درحالیکه',
        'درست',
        'درست و حسابی',
        'درسته',
        'درصورتی که',
        'درعین حال',
        'درمجموع',
        'درواقع',
        'درون',
        'دریغ',
        'دریغا',
        'درین',
        'دسته دسته',
        'دشمنیم',
        'دقیقا',
        'دم',
        'دنبالِ',
        'ده',
        'دهد',
        'دهم',
        'دهند',
        'دهی',
        'دهید',
        'دهیم',
        'دو',
        'دو روزه',
        'دوباره',
        'دوم',
        'دیده',
        'دیر',
        'دیرت',
        'دیرم',
        'دیروز',
        'دیشب',
        'دیوانه‌ای',
        'دیوی',
        'دیگر',
        'دیگران',
        'دیگری',
        'دیگه',
        'ذ',
        'ذاتاً',
        'ر',
        'را',
        'راجع به',
        'راحت',
        'راسا',
        'راست',
        'راستی',
        'رسما',
        'رسید',
        'رسیده',
        'رشته',
        'رفت',
        'رفتارهاست',
        'رفته',
        'رنجند',
        'رهگشاست',
        'رو',
        'رواست',
        'روب',
        'روبروست',
        'روز',
        'روز به روز',
        'روزانه',
        'روزه ایم',
        'روزه ست',
        'روزه م',
        'روزهای',
        'روزه‌ای',
        'روش',
        'روی',
        'رویش',
        'رویِ',
        'ریزی',
        'ز',
        'زشتکارانند',
        'زمان',
        'زمانی',
        'زمینه',
        'زنند',
        'زهی',
        'زود',
        'زودتر',
        'زیاد',
        'زیاده',
        'زیر',
        'زیرا',
        'زیرِ',
        'زیرچشمی',
        'س',
        'سابق',
        'ساخته',
        'ساده اند',
        'سازی',
        'سالانه',
        'سالته',
        'سالم‌تر',
        'سالهاست',
        'سالیانه',
        'ساکنند',
        'سایر',
        'سخت',
        'سخته',
        'سر',
        'سراسر',
        'سرانجام',
        'سراپا',
        'سری',
        'سریع',
        'سریعا',
        'سریعاً',
        'سریِ',
        'سعی',
        'سمتِ',
        'سه باره',
        'سهواً',
        'سوم',
        'سوی',
        'سویِ',
        'سپس',
        'سیاه چاله هاست',
        'سیخ',
        'ش',
        'شان',
        'شاهدند',
        'شاهدیم',
        'شاید',
        'شبهاست',
        'شخصا',
        'شخصاً',
        'شد',
        'شدم',
        'شدن',
        'شدند',
        'شده',
        'شدی',
        'شدید',
        'شدیدا',
        'شدیداً',
        'شدیم',
        'شش',
        'شش نداشته',
        'شما',
        'شماری',
        'شماست',
        'شمایند',
        'شناسی',
        'شو',
        'شود',
        'شوراست',
        'شوقم',
        'شوم',
        'شوند',
        'شونده',
        'شوی',
        'شوید',
        'شویم',
        'شیرین',
        'شیرینه',
        'شیک',
        'ص',
        'صد',
        'صددرصد',
        'صرفا',
        'صرفاً',
        'صریحاً',
        'صندوق هاست',
        'صورت',
        'ض',
        'ضدِّ',
        'ضدِّ',
        'ضمن',
        'ضمناً',
        'ط',
        'طبعا',
        'طبعاً',
        'طبقِ',
        'طبیعتا',
        'طرف',
        'طریق',
        'طلبکارانه',
        'طور',
        'طی',
        'ظ',
        'ظاهرا',
        'ظاهراً',
        'ع',
        'عاجزانه',
        'عاقبت',
        'عبارتند',
        'عجب',
        'عجولانه',
        'عدم',
        'عرفانی',
        'عقب',
        'عقبِ',
        'علاوه بر',
        'علاوه بر آن',
        'علاوه برآن',
        'علناً',
        'علّتِ',
        'علی الظاهر',
        'علی رغم',
        'علیرغم',
        'علیه',
        'عمدا',
        'عمداً',
        'عمدتا',
        'عمدتاً',
        'عمده',
        'عمل',
        'عملا',
        'عملاً',
        'عملی اند',
        'عموم',
        'عموما',
        'عموماً',
        'عنقریب',
        'عنوان',
        'عنوانِ',
        'عیناً',
        'غ',
        'غالبا',
        'غزالان',
        'غیر',
        'غیرقانونی',
        'ف',
        'فاقد',
        'فبها',
        'فر',
        'فردا',
        'فعلا',
        'فعلاً',
        'فقط',
        'فلان',
        'فلذا',
        'فوق',
        'فکر',
        'ق',
        'قاالند',
        'قابل',
        'قاطبه',
        'قاطعانه',
        'قاعدتاً',
        'قانوناً',
        'قبل',
        'قبلا',
        'قبلاً',
        'قبلند',
        'قدر',
        'قدری',
        'قصدِ',
        'قضایاست',
        'قطعا',
        'قطعاً',
        'ل',
        'لااقل',
        'لاجرم',
        'لب',
        'لذا',
        'لزوماً',
        'لطفا',
        'لطفاً',
        'لیکن',
        'م',
        'ما',
        'مادامی',
        'ماست',
        'مامان مامان گویان',
        'مان',
        'مانند',
        'مانندِ',
        'مبادا',
        'متؤسفانه',
        'متاسفانه',
        'متعاقبا',
        'متفاوتند',
        'مثل',
        'مثلا',
        'مثلِ',
        'مجانی',
        'مجبورند',
        'مجددا',
        'مجدداً',
        'مجموعا',
        'مجموعاً',
        'محتاجند',
        'محکم',
        'محکم‌تر',
        'مخالفند',
        'مختلف',
        'مخصوصاً',
        'مدام',
        'مدت',
        'مدتهاست',
        'مدّتی',
        'مذهبی اند',
        'مرا',
        'مرتب',
        'مردانه',
        'مردم',
        'مردم اند',
        'مرسی',
        'مستحضرید',
        'مستقیما',
        'مستند',
        'مسلما',
        'مشت',
        'مشترکاً',
        'مشغولند',
        'مطمانا',
        'مطمانم',
        'مطمینا',
        'مع الاسف',
        'مع ذلک',
        'معتقدم',
        'معتقدند',
        'معتقدیم',
        'معدود',
        'معذوریم',
        'معلومه',
        'معمولا',
        'معمولاً',
        'معمولی',
        'مغرضانه',
        'مفیدند',
        'مقابل',
        'مقدار',
        'مقصرند',
        'مقصری',
        'ملیارد',
        'ملیون',
        'ممکن',
        'ممیزیهاست',
        'من',
        'منتهی',
        'منطقی',
        'منی',
        'مواجهند',
        'موارد',
        'موجودند',
        'مورد',
        'موقتا',
        'مکرر',
        'مکرراً',
        'مگر',
        'مگر آن که',
        'مگر این که',
        'مگو',
        'می',
        'میان',
        'میزان',
        'میلیارد',
        'میلیون',
        'میکند',
        'میکنم',
        'میکنند',
        'میکنی',
        'میکنید',
        'میکنیم',
        'می‌تواند',
        'می‌خواهیم',
        'می‌داند',
        'می‌رسد',
        'می‌رود',
        'می‌شود',
        'می‌کنم',
        'می‌کنند',
        'می‌کنیم',
        'ن',
        'ناامید',
        'ناخواسته',
        'ناراضی اند',
        'ناشی',
        'نام',
        'ناگاه',
        'ناگزیر',
        'ناگهان',
        'ناگهانی',
        'نباید',
        'نبش',
        'نبود',
        'نخست',
        'نخستین',
        'نخواهد',
        'نخواهم',
        'نخواهند',
        'نخواهی',
        'نخواهید',
        'نخواهیم',
        'نخودی',
        'ندارد',
        'ندارم',
        'ندارند',
        'نداری',
        'ندارید',
        'نداریم',
        'نداشت',
        'نداشتم',
        'نداشتند',
        'نداشته',
        'نداشتی',
        'نداشتید',
        'نداشتیم',
        'نزد',
        'نزدِ',
        'نزدیک',
        'نزدیکِ',
        'نسبتا',
        'نشان',
        'نشده',
        'نظیر',
        'نفرند',
        'نماید',
        'نموده',
        'نمی',
        'نمی‌شود',
        'نمی‌کند',
        'نه',
        'نه تنها',
        'نهایتا',
        'نهایتاً',
        'نوع',
        'نوعاً',
        'نوعی',
        'نکرده',
        'نکن',
        'نکند',
        'نکنم',
        'نکنند',
        'نکنی',
        'نکنید',
        'نکنیم',
        'نگاه',
        'نگو',
        'نیازمندند',
        'نیز',
        'نیست',
        'نیستم',
        'نیستند',
        'نیستیم',
        'نیمی',
        'ه',
        'ها',
        'های',
        'هایی',
        'هبچ',
        'هر',
        'هر از گاهی',
        'هر چند',
        'هر چند که',
        'هر چه',
        'هرچند',
        'هرچه',
        'هرکس',
        'هرگاه',
        'هرگز',
        'هزار',
        'هست',
        'هستم',
        'هستند',
        'هستی',
        'هستید',
        'هستیم',
        'هفت',
        'هق هق کنان',
        'هم',
        'هم اکنون',
        'هم اینک',
        'همان',
        'همان طور که',
        'همان گونه که',
        'همانا',
        'همانند',
        'همانها',
        'همدیگر',
        'همزمان',
        'همه',
        'همه روزه',
        'همه ساله',
        'همه شان',
        'همهٌ',
        'همه‌اش',
        'همواره',
        'همچنان',
        'همچنان که',
        'همچنین',
        'همچون',
        'همچین',
        'همگان',
        'همگی',
        'همیشه',
        'همین',
        'همین که',
        'هنوز',
        'هنگام',
        'هنگامِ',
        'هنگامی',
        'هنگامی که',
        'هوی',
        'هی',
        'هیچ',
        'هیچ گاه',
        'هیچکدام',
        'هیچکس',
        'هیچگاه',
        'هیچگونه',
        'هیچی',
        'و',
        'و لا غیر',
        'وابسته اند',
        'واقعا',
        'واقعاً',
        'واقعی',
        'واقفند',
        'واما',
        'وای',
        'وجود',
        'وحشت زده',
        'وسطِ',
        'وضع',
        'وقتی',
        'وقتی که',
        'وقتیکه',
        'ولی',
        'وگرنه',
        'وگو',
        'وی',
        'ویا',
        'ویژه',
        'ّه',
        '٪',
        'پ',
        'پارسال',
        'پارسایانه',
        'پاره‌ای',
        'پاعینِ',
        'پایین ترند',
        'پدرانه',
        'پرسان',
        'پروردگارا',
        'پریروز',
        'پس',
        'پس از',
        'پس فردا',
        'پشت',
        'پشتوانه اند',
        'پشیمونی',
        'پنج',
        'پهن شده',
        'پی',
        'پی درپی',
        'پیدا',
        'پیداست',
        'پیرامون',
        'پیش',
        'پیشاپیش',
        'پیشتر',
        'پیشِ',
        'پیوسته',
        'چ',
        'چاپلوسانه',
        'چت',
        'چته',
        'چرا',
        'چرا که',
        'چشم بسته',
        'چطور',
        'چقدر',
        'چنان',
        'چنانچه',
        'چنانکه',
        'چند',
        'چند روزه',
        'چندان',
        'چنده',
        'چندین',
        'چنین',
        'چه',
        'چه بسا',
        'چه طور',
        'چهار',
        'چو',
        'چون',
        'چکار',
        'چگونه',
        'چی',
        'چیز',
        'چیزی',
        'چیزیست',
        'چیست',
        'چیه',
        'ژ',
        'ک',
        'کارند',
        'کاش',
        'کاشکی',
        'کامل',
        'کاملا',
        'کاملاً',
        'کتبا',
        'کجا',
        'کجاست',
        'کدام',
        'کرد',
        'کردم',
        'کردن',
        'کردند',
        'کرده',
        'کردی',
        'کردید',
        'کردیم',
        'کس',
        'کسانی',
        'کسی',
        'کل',
        'کلا',
        'کلی',
        'کلیه',
        'کم',
        'کم کم',
        'کمااینکه',
        'کماکان',
        'کمتر',
        'کمتره',
        'کمتری',
        'کمی',
        'کن',
        'کنار',
        'کنارش',
        'کنارِ',
        'کنایه‌ای',
        'کند',
        'کنم',
        'کنند',
        'کننده',
        'کنون',
        'کنونی',
        'کنی',
        'کنید',
        'کنیم',
        'که',
        'کو',
        'کَی',
        'کی',
        'گ',
        'گاه',
        'گاهی',
        'گذاری',
        'گذاشته',
        'گذشته',
        'گردد',
        'گردند',
        'گرفت',
        'گرفتارند',
        'گرفتم',
        'گرفتن',
        'گرفتند',
        'گرفته',
        'گرفتی',
        'گرفتید',
        'گرفتیم',
        'گروهی',
        'گرچه',
        'گفت',
        'گفتم',
        'گفتن',
        'گفتند',
        'گفته',
        'گفتی',
        'گفتید',
        'گفتیم',
        'گه',
        'گهگاه',
        'گو',
        'گونه',
        'گوی',
        'گویا',
        'گوید',
        'گویم',
        'گویند',
        'گویی',
        'گویید',
        'گوییم',
        'گیر',
        'گیرد',
        'گیرم',
        'گیرند',
        'گیری',
        'گیرید',
        'گیریم',
        'ی',
        'یا',
        'یاب',
        'یابد',
        'یابم',
        'یابند',
        'یابی',
        'یابید',
        'یابیم',
        'یارب',
        'یافت',
        'یافتم',
        'یافتن',
        'یافته',
        'یافتی',
        'یافتید',
        'یافتیم',
        'یعنی',
        'یقینا',
        'یقیناً',
        'یه',
        'یواش یواش',
        'یک',
        'یک جوری',
        'یک کم',
        'یک کمی',
        'یکدیگر',
        'یکریز',
        'یکسال',
        'یکهزار',
        'یکی',
        '۰',
        '۱',
        '۲',
        '۳',
        '۴',
        '۵',
        '۶',
        '۷',
        '۸',
        '۹',
        '…',
        '﻿و',
        'کن',
        'کرد',
        'کردن',
        'باش',
        'بود',
        'بودن',
        'شو',
        'شد',
        'شدن',
        'دار',
        'داشت',
        'داشتن',
        'خواه',
        'خواست',
        'خواستن',
        'گوی',
        'گفت',
        'گفتن',
        'گیر',
        'گرفت',
        'گرفتن',
        'آی',
        'آمد',
        'آمدن',
        'توان',
        'توانست',
        'توانستن',
        'یاب',
        'یافت',
        'یافتن',
        'آور',
        'آورد',
        'آوردن',
        'دیگران',
        'همچنان',
        'مدت',
        'چیز',
        'سایر',
        'جا',
        'طی',
        'کل',
        'کنونی',
        'بیرون',
        'مثلا',
        'کامل',
        'کاملا',
        'آنکه',
        'موارد',
        'واقعی',
        'امور',
        'اکنون',
        'بطور',
        'بخشی',
        'تحت',
        'چگونه',
        'عدم',
        'نوعی',
        'حاضر',
        'وضع',
        'مقابل',
        'کنار',
        'خویش',
        'نگاه',
        'درون',
        'زمانی',
        'بنابراین',
        'تو',
        'خیلی',
        'بزرگ',
        'خودش',
        'جز',
        'اینجا',
        'مختلف',
        'توسط',
        'نوع',
        'همچنین',
        'آنجا',
        'قبل',
        'جناح',
        'اینها',
        'طور',
        'شاید',
        'ایشان',
        'جهت',
        'طریق',
        'مانند',
        'پیدا',
        'ممکن',
        'کسانی',
        'جای',
        'کسی',
        'غیر',
        'بی',
        'قابل',
        'درباره',
        'جدید',
        'وقتی',
        'اخیر',
        'چرا',
        'بیش',
        'روی',
        'طرف',
        'جریان',
        'زیر',
        'آنچه',
        'البته',
        'فقط',
        'چیزی',
        'چون',
        'برابر',
        'هنوز',
        'بخش',
        'زمینه',
        'بین',
        'بدون',
        'استفاد',
        'همان',
        'نشان',
        'بسیاری',
        'بعد',
        'عمل',
        'روز',
        'اعلام',
        'چند',
        'آنان',
        'بلکه',
        'امروز',
        'تمام',
        'بیشتر',
        'آیا',
        'برخی',
        'علیه',
        'دیگری',
        'ویژه',
        'گذشته',
        'انجام',
        'حتی',
        'داده',
        'سوی',
        'ولی',
        'زمان',
        'حال',
        'تنها',
        'بسیار',
        'یعنی',
        'عنوان',
        'همین',
        'هبچ',
        'پیش',
        'وی',
        'یکی',
        'اینکه',
        'وجود',
        'شما',
        'پس',
        'چنین',
        'میان',
        'مورد',
        'چه',
        'اگر',
        'همه',
        'نه',
        'دیگر',
        'آنها',
        'باید',
        'هر',
        'او',
        'ما',
        'من',
        'تا',
        'نیز',
        'اما',
        'یک',
        'خود',
        'بر',
        'یا',
        'هم',
        'را',
        'این',
        'با',
        'آن',
        'برای',
        'و',
        'در',
        'به',
        'که',
        'از',
        '!',
        '"',
        '#',
        '(',
        ')',
        '*',
        '-',
        '.',
        '/',
        ':',
        '[',
        ']',
        '«',
        '»',
        '،',
        '؛',
        '؟',
        '۰',
        '۱',
        '۲',
        '۳',
        '۴',
        '۵',
        '۶',
        '۷',
        '۸',
        '۹',
        '…',
        '$',
        '',
        'و',
        'در',
        'به',
        'از',
        'كه',
        'مي',
        'اين',
        'است',
        'را',
        'با',
        'هاي',
        'براي',
        'آن',
        'يك',
        'شود',
        'شده',
        'خود',
        'ها',
        'كرد',
        'شد',
        'اي',
        'تا',
        'كند',
        'بر',
        'بود',
        'گفت',
        'نيز',
        'وي',
        'هم',
        'كنند',
        'دارد',
        'ما',
        'كرده',
        'يا',
        'اما',
        'بايد',
        'دو',
        'اند',
        'هر',
        'خواهد',
        'او',
        'مورد',
        'آنها',
        'باشد',
        'ديگر',
        'مردم',
        'نمي',
        'بين',
        'پيش',
        'پس',
        'اگر',
        'همه',
        'صورت',
        'يكي',
        'هستند',
        'بي',
        'من',
        'دهد',
        'هزار',
        'نيست',
        'استفاده',
        'داد',
        'داشته',
        'داشت',
        'چه',
        'همچنين',
        'كردند',
        'داده',
        'بوده',
        'دارند',
        'همين',
        'ميليون',
        'سوي',
        'شوند',
        'بيشتر',
        'بسيار',
        'روي',
        'گرفته',
        'هايي',
        'تواند',
        'اول',
        'نام',
        'هيچ',
        'چند',
        'جديد',
        'بيش',
        'شدن',
        'كردن',
        'كنيم',
        'نشان',
        'حتي',
        'اينكه',
        'ولی',
        'توسط',
        'چنين',
        'برخي',
        'نه',
        'ديروز',
        'دوم',
        'درباره',
        'بعد',
        'مختلف',
        'گيرد',
        'شما',
        'گفته',
        'آنان',
        'بار',
        'طور',
        'گرفت',
        'دهند',
        'گذاري',
        'بسياري',
        'طي',
        'بودند',
        'ميليارد',
        'بدون',
        'تمام',
        'كل',
        'تر  براساس',
        'شدند',
        'ترين',
        'امروز',
        'باشند',
        'ندارد',
        'چون',
        'قابل',
        'گويد',
        'ديگري',
        'همان',
        'خواهند',
        'قبل',
        'آمده',
        'اكنون',
        'تحت',
        'طريق',
        'گيري',
        'جاي',
        'هنوز',
        'چرا',
        'البته',
        'كنيد',
        'سازي',
        'سوم',
        'كنم',
        'بلكه',
        'زير',
        'توانند',
        'ضمن',
        'فقط',
        'بودن',
        'حق',
        'آيد',
        'وقتي',
        'اش',
        'يابد',
        'نخستين',
        'مقابل',
        'خدمات',
        'امسال',
        'تاكنون',
        'مانند',
        'تازه',
        'آورد',
        'فكر',
        'آنچه',
        'نخست',
        'نشده',
        'شايد',
        'چهار',
        'جريان',
        'پنج',
        'ساخته',
        'زيرا',
        'نزديك',
        'برداري',
        'كسي',
        'ريزي',
        'رفت',
        'گردد',
        'مثل',
        'آمد',
        'ام',
        'بهترين',
        'دانست',
        'كمتر',
        'دادن',
        'تمامي',
        'جلوگيري',
        'بيشتري',
        'ايم',
        'ناشي',
        'چيزي',
        'آنكه',
        'بالا',
        'بنابراين',
        'ايشان',
        'بعضي',
        'دادند',
        'داشتند',
        'برخوردار',
        'نخواهد',
        'هنگام',
        'نبايد',
        'غير',
        'نبود',
        'ديده',
        'وگو',
        'داريم',
        'چگونه',
        'بندي',
        'خواست',
        'فوق',
        'ده',
        'نوعي',
        'هستيم',
        'ديگران',
        'همچنان',
        'سراسر',
        'ندارند',
        'گروهي',
        'سعي',
        'روزهاي',
        'آنجا',
        'يكديگر',
        'كردم',
        'بيست',
        'بروز',
        'سپس',
        'رفته',
        'آورده',
        'نمايد',
        'باشيم',
        'گويند',
        'زياد',
        'خويش',
        'همواره',
        'گذاشته',
        'شش  نداشته',
        'شناسي',
        'خواهيم',
        'آباد',
        'داشتن',
        'نظير',
        'همچون',
        'باره',
        'نكرده',
        'شان',
        'سابق',
        'هفت',
        'دانند',
        'جايي',
        'بی',
        'جز',
        'زیرِ',
        'رویِ',
        'سریِ',
        'تویِ',
        'جلویِ',
        'پیشِ',
        'عقبِ',
        'بالایِ',
        'خارجِ',
        'وسطِ',
        'بیرونِ',
        'سویِ',
        'کنارِ',
        'پاعینِ',
        'نزدِ',
        'نزدیکِ',
        'دنبالِ',
        'حدودِ',
        'برابرِ',
        'طبقِ',
        'مانندِ',
        'ضدِّ',
        'هنگامِ',
        'برایِ',
        'مثلِ',
        'بارة',
        'اثرِ',
        'تولِ',
        'علّتِ',
        'سمتِ',
        'عنوانِ',
        'قصدِ',
        'روب',
        'جدا',
        'کی',
        'که',
        'چیست',
        'هست',
        'کجا',
        'کجاست',
        'کَی',
        'چطور',
        'کدام',
        'آیا',
        'مگر',
        'چندین',
        'یک',
        'چیزی',
        'دیگر',
        'کسی',
        'بعری',
        'هیچ',
        'چیز',
        'جا',
        'کس',
        'هرگز',
        'یا',
        'تنها',
        'بلکه',
        'خیاه',
        'بله',
        'بلی',
        'آره',
        'آری',
        'مرسی',
        'البتّه',
        'لطفاً',
        'ّه',
        'انکه',
        'وقتیکه',
        'همین',
        'پیش',
        'مدّتی',
        'هنگامی',
        'مان',
        'تان'
    ]
};
